import React from "react";
import { useTranslation } from "react-i18next";

const TableLabels = () => {
  const [_] = useTranslation("global");
  const role = localStorage.getItem("role");

  const roles_labels = {
    employee: [
      _("panel.date"),
      _("panel.thebank"),
      _("panel.affiliatesBalance"),
      _("panel.sellersBalance"),
      _("panel.sys_Balance"), 
      _("panel.fulfillmentBalance"), 
      _("panel.totalBalance"),
    ],
    admin: [
      _("panel.date"),
      _("panel.thebank"),
      _("panel.affiliatesBalance"),
      _("panel.sellersBalance"),
      _("panel.sys_Balance"),
      _("panel.fulfillmentBalance"), 
      _("panel.totalBalance"),
    ],
  };

  return (
    <tr>
      {roles_labels[role].map((label) => {
        return <th>{label}</th>;
      })}
    </tr>
  );
};

export default TableLabels;
